import { render, staticRenderFns } from "./AContent.vue?vue&type=template&id=232f8639&"
import script from "./AContent.vue?vue&type=script&lang=js&"
export * from "./AContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports